import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NavController } from 'ionic-angular';
import {
    PlatformService, LoggingService, TokenService, LocalStorageService, NotificationsService,
    Confirmation, StripeService, InstituteSearchResult, PriceService, StripeCreateSessionResponse,
    TeamEvent, TicketsService, StorageData
} from '@varsity/services';
import { BaseComponent } from '@varsity/components';
import { PopoverController, ToastController } from 'ionic-angular';
import { DisplayMessageComponent } from '../display-message/display-message';
import { TimeService } from '@varsity/services';
import { InAppBrowser } from '@ionic-native/in-app-browser';

declare var Stripe: any;

/**
 * Generated class for the StripeComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'stripe',
    templateUrl: 'stripe.html'
})
export class StripeComponent extends BaseComponent {
    @Input() public sponsor: any;
    @Input() public confirmation: any;
    @Input() public events: any[];
    @Input() public insuranceSelection: any;

    @Output() public beforeStripe: EventEmitter<() => void> = new EventEmitter();

    constructor(
        protected platformService: PlatformService,
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected priceService: PriceService,
        protected popoverCtrl: PopoverController,
        protected toastCtrl: ToastController,
        protected ticketsService: TicketsService,
        protected stripeService: StripeService,
        protected timeService: TimeService,
        protected iab: InAppBrowser,
        protected navCtrl: NavController,
    ) {
        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "StripeComponent"
        );
    }

    logIngAndAdvanceToPayment(loggedIn) {
        if(loggedIn == true){
            if (this.beforeStripe.observers.length > 0) {
                this.beforeStripe.emit(()=>{
                    this.onBeforeStripe();
                })}
        }else{
            if (this.beforeStripe.observers.length > 0) {
                this.beforeStripe.emit(()=>{
                    this.openLoginPopover('login', {}, () => {
                        if (this.notificationsService.loggedInUser) {
                            // the user is logged in
                            this.onBeforeStripe();
                        }
                    });
                })}
            else{
                this.openLoginPopover('login', {}, () => {
                    if (this.notificationsService.loggedInUser) {
                        // the user is logged in
                        this.onBeforeStripe();
                    }
                });
            }
        }

        // this.openLoginPopover('login', {}, () => {
        //     if (this.notificationsService.loggedInUser) {
        //         // the user is logged in
        //         this.onBeforeStripe();
        //     }
        // });
    }

    onBeforeStripe() {
        
        this.callStripe();

    }

    callStripe() {
        let confirmation = this.confirmation as Confirmation;
        let sponsor = this.sponsor as InstituteSearchResult;

        // clone the object
        confirmation = JSON.parse(JSON.stringify(confirmation)) as Confirmation;

        this.tokenService.ensureValidToken(true).then((token) => {
            if (this.isUserLoggedIn()) {
                // double check the timer did not expire meanwhile
                var now = new Date();
                // const remainingTime = (new Date(confirmation.ReserveTimeoutLocal).getTime() - now.getTime()) / 1000;
                // if (remainingTime < 0) {
                //     return;
                // }

                let transactionTotal = this.priceService.priceToFloat(confirmation.TransactionTotal.replace("$", ''));

                try{
                     transactionTotal = this.priceService.priceToFloat(confirmation.TransactionTotal);
                }catch(e){
                    console.log(e)
                }
                console.log(transactionTotal)
                // generate quote id
                let promise = new Promise<number>((resolve, reject) => {
                    try{if (this.insuranceSelection && this.insuranceSelection.selected) {
                        this.ticketsService.saveInsuranceData({ insuranceData: this.insuranceSelection.data.insuranceData, QuoteToken: this.insuranceSelection.token },
                            (confirmation.tickets || confirmation.nti)[0].EventID,
                            transactionTotal + this.insuranceSelection.total)
                            .subscribe((quote) => {
                                resolve(quote);
                            });

                    } else {
                        resolve(0);
                    }}catch(e){
                        console.log(e)
                    }

                });

                // update purchase confirmation token
                let promise2 = new Promise<string>((resolve, reject) => {
                    if (this.insuranceSelection && this.insuranceSelection.selected) {
                        this.ticketsService.updateConfirmation(confirmation.PurchaseToken, transactionTotal + this.insuranceSelection.total,
                            confirmation.tickets.length)
                            .subscribe((newToken) => {
                                resolve(newToken);
                            });
                    } else {
                        resolve("");
                    }
                });

                promise.then((quoteId) => {
                    promise2.then((newToken) => {
                        this.ticketsService.resetTicketTimeout().subscribe((value) => {
                            //Check for nti only purchase, reserve ticket above will be 0 so reset
                            var blnNTIOnly = false;
                            if (confirmation.tickets == null && confirmation.nti != null) {
                                value = 1;
                                blnNTIOnly = true;
                            }
                            if (value) {
                                // If timer has value, generate the target expiration date
                                // save it in session storage

                                if (blnNTIOnly == false) {
                                    confirmation.ReserveTimeoutLocal = this.timeService.getExpirationDateTime(value).toString();

                                    if (this.confirmation) {
                                        (this.confirmation as Confirmation).ReserveTimeoutLocal = confirmation.ReserveTimeoutLocal;
                                        // no need to notify for this
                                        this.localStorageService.add('confirmation', JSON.stringify(this.confirmation));
                                    }
                                }

                                let href = window.location.href;
                                let index = href.indexOf('#');
                                if (index > -1) {
                                    href = href.substr(0, index);
                                }

                                let hasInsurance = quoteId > 0 && newToken;
                                if (hasInsurance) {
                                    // replace the confirmation
                                    confirmation.QuoteID = quoteId || 0;
                                    confirmation.QuoteAmount = (this.insuranceSelection || { total: 0 }).total;
                                    confirmation.insurance.nti.SelectedFlag = true;
                                    confirmation.insurance.nti.AmtPerTicket = confirmation.QuoteAmount;
                                    confirmation.insurance.nti.OrderAmtQty = 1;
                                    confirmation.nti.push(confirmation.insurance.nti);
                                    confirmation.TransactionTotal = transactionTotal + this.insuranceSelection.total;
                                    confirmation.PurchaseToken = newToken;
                                }

                                let customerID = (this.getUser() ? this.getUser().CustomerID : 0);

                                var callStripe = () => {
                                    this.stripeService
                                        .createSession(confirmation, this.priceService.priceToFloat(confirmation.TransactionTotal), sponsor.DBName, href, customerID)
                                        .finally(() => {

                                        })
                                        .takeUntil(this.componentDestroyed$)
                                        .subscribe(data => {
                                            if (hasInsurance) {
                                                confirmation.QuoteToken = data.QuoteToken;
                                                confirmation.WidgetQuoteToken = (this.insuranceSelection || { token: "" }).token;
                                                // TODO make sure to add the insurance confirmation object as well, if needed
                                                //this.localStorageService.add('temp-insurance-confirmation', JSON.stringify(confirmation));
                                            }
                                            confirmation.pcipay.ReturnURL = data.pcipay.ReturnURL;
                                            confirmation.pcipay.Color = data.Color;
                                            this.localStorageService.add("confirmation", JSON.stringify(confirmation));
                                            this.localStorageService.add("ClientSecret", data.ClientSecret);
                                            this.localStorageService.add("Customer", JSON.stringify(data.customer));
                                            this.localStorageService.add("payIntent", data.Token);

                                            //if (data.pcipay.ReturnURL.indexOf('StripeTransfer') > 0) {
                                            //    let storageData: StorageData = {
                                            //        User: JSON.parse(this.localStorageService.get('user')),
                                            //        DefaultSiteLayout: JSON.parse(this.localStorageService.get('defaultSiteLayout')),
                                            //        Token: data.Token,
                                            //        TokenExpireDate: this.localStorageService.get('tokenExpireDate'),
                                            //        Confirmation: confirmation
                                            //    }
                                            //    this.tokenService.saveCartToken(data.Token, 1, storageData).subscribe(result => {
                                            //        if (result == 1) {
                                            //            this.redirectToStripe(data);
                                            //            this.navCtrl.push('pay', {
                                            //                sessionID: ''
                                            //            }, {
                                            //                    id: `pay`
                                            //                });
                                            //        }
                                            //    });
                                            //} else {
                                                this.navCtrl.push('pay', {
                                                    sessionID: ''
                                                }, {
                                                        id: `pay`
                                                    });
                                            //}
                                           


                                            // before the redirect, save the temp-token, temp-user and temp-confirmation
                                            //this.localStorageService.add('temp-token', this.localStorageService.get('token'));
                                            //this.localStorageService.add('temp-user', this.localStorageService.get('user'));
                                            //this.localStorageService.add('temp-confirmation', this.localStorageService.get('confirmation'));
                                            //if (hasInsurance) {
                                            //    confirmation.QuoteToken = data.QuoteToken;
                                            //    confirmation.WidgetQuoteToken = (this.insuranceSelection || { token: "" }).token;
                                            //    this.localStorageService.add('temp-insurance-confirmation', JSON.stringify(confirmation));
                                            //}
                                            //this.localStorageService.add('temp-tokenExpireDate', this.localStorageService.get('tokenExpireDate'));

                                            //this.redirectToStripe(data);
                                        }, (error) => {
                                            this.handleError(error);
                                        });
                                }

                                let mobileOnlyTicketsFound = false;
                                let mobileOnlyText: string = "";

                                let events = this.events as TeamEvent[];
                                for (let ev of events) {
                                    if (ev.GateValidationOnly && !mobileOnlyTicketsFound) {
                                        mobileOnlyTicketsFound = true;
                                        mobileOnlyText = ev.GateValidationText;
                                    }
                                }

                                if (mobileOnlyTicketsFound) {
                                    super.showPopover(DisplayMessageComponent, {
                                        icon: "card",
                                        header: "Proceed to payment",
                                        content: [mobileOnlyText, "Do you agree and wish to proceed to payment?"],
                                        buttons: [{ tag: 'no', text: 'No' }, { tag: 'yes', text: 'Yes' }],
                                        footer: null,
                                    }, 'display-message', (d) => {
                                        if (d.button && d.button.tag == "yes") {
                                            callStripe();
                                        }
                                    });
                                } else {
                                    callStripe();
                                }
                            }

                        })
                    }, () => {

                    });
                }, () => {

                });
            } else {
                this.showNotification('Unable to perform action, you need to login first', undefined, undefined, "warning");
            }
        });
    }

    redirectToStripe(session: StripeCreateSessionResponse) {
        this.loggingService.debug(session);

        if (session.PublicKey) {
            // get it from the server
            var stripe = Stripe(session.PublicKey);

            stripe.redirectToCheckout({
                // Make the id field from the Checkout Session creation API response
                // available to this file, so you can provide it as parameter here
                // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
                sessionId: session.Token
            }).then(function (result) {
                // If `redirectToCheckout` fails due to a browser or network
                // error, display the localized error message to your customer
                // using `result.error.message`.

                this.loggingService.debug(result);
            });
        } else {
            this.showNotification('Cannot process payment at this point. Please try again later.', undefined, undefined, "error");
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/stripe/stripe.ts